import postAPI from './postAPI.js'

export default async function postUpdateFieldValue(body) {
    const data = await postAPI('taskinstances/fields/updatevalue', body);
    return data;
}
